// schemas/formSchema.js
import * as yup from "yup";

export const schemaContattiCare = yup.object().shape({
  nomeCognome: yup.string().required("*Il nome e cognome è obbligatorio"),
  telefono: yup
    .string()
    .required("*Il telefono è obbligatorio")
    .matches(/^\+?\d{10,14}$/, "Inserisci un numero di telefono valido"),
  email: yup.string().email("Inserisci un'email valida").required("*L'email è obbligatoria"),
  provincia: yup.string().required("*Seleziona una provincia"),
  InteressatoA: yup.string().required("*Seleziona a cosa sei interessato"),
  ComeCiHaConosciuto: yup.string().required("*Seleziona come ci hai conosciuto"),
  consenso: yup.boolean().oneOf([true],"*Accetta i termini e le condizioni"),
});

export const schemaOroPrestige = yup.object().shape({
  nomeCognome: yup.string().required("*Il nome e cognome è obbligatorio"),
  telefono: yup
    .string()
    .required("*Il telefono è obbligatiorio")
    .matches(/^\+?\d{10,14}$/, "Inserisci un numero di telefono valido"),
  email: yup.string().email("Inserisci un'email valida").required("*L'email è obbligatoria"),
  indirizzo: yup.string().required("*L'indirizzo è obbligatorio"),
  provincia: yup.string().required("*Seleziona una provincia"),
  InteressatoA: yup.string().required("*Seleziona a cosa sei interessato"),
  ComeCiHaConosciuto: yup.string().required("*Seleziona come ci hai conosciuto"),
  consenso: yup.boolean().oneOf([true],"*Accetta i termini e le condizioni"),
});

export const schemaDivisionePrivate = yup.object().shape({
  nomeCognome: yup.string().required("*Il nome e cognome è obbligatorio"),
  telefono: yup
    .string()
    .required("*Il telefono è obbligatorio")
    .matches(/^\+?\d{10,14}$/, "Inserisci un numero di telefono valido"),
  email: yup.string().email("Inserisci un'email valida").required("*L'email è obbligatoria"),
  provincia: yup.string().required("*Seleziona una provincia"),
  ComeCiHaConosciuto: yup.string().required("*Seleziona come ci hai conosciuto"),
  consenso: yup.boolean().oneOf([true],"*Accetta i termini e le condizioni"),
});
